import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import NavBar from './components/NavBar'; // Your NavBar component

// Your individual page components
import GeneratorPage from './pages/GeneratorPage';
import FaqPage from './pages/FaqPage';

function App() {
    return (
        <Router>
                <NavBar />
                <Routes>
                    <Route path="/" element={<GeneratorPage />} />
                    <Route path="/faq" element={<FaqPage />} />
                </Routes>
            <Box component="footer" sx={{ mt: 6, py: 4, textAlign: 'center', borderTop: '1px solid #ddd' }}>
                <Typography variant="body2" color="text.secondary">
                    This tool generates random, valid-looking IBAN numbers for educational and testing purposes. These IBANs are not linked to any real accounts and should not be used for financial transactions.                </Typography>
            </Box>
        </Router>
    );
}

export default App;
